export function alertsQueryDslConnection({
	after = null,
	county,
	drugType,
	first = 10,
	locale,
	now = new Date().toISOString(),
	siteKey = '/overdosefare',
}: {
	after? : string | null;
	county?: string | null;
	drugType?: string | null;
	first?: number;
	locale: string;
	now?: string;
	siteKey?: string;
}): string {
	return `query Alerts {
	guillotine(
		siteKey: "${siteKey}"
	) {
		counties: queryDslConnection(
			aggregations: [
				{
					name: "county"
					terms: {
						field: "data.locationCounty"
						minDocCount: 0
						order: "_term ASC"
						size: 100
					}
				},
			]
			first: 0
			query: {
				boolean: {
					must: [
						{
							term: {
								field: "type",
								value: {
									string: "overdosefare:alert"
								}
							}
						}, {
							range: {
								field: "data.expires"
								lt: {
									string: "${now}"
								}
							}
						}
						${drugType ? `, {
							fulltext: {
								fields: ["data.drugType"]
								query: "${drugType}"
							}
						}` : ''}
					]
				}
			}
		) {
			aggregationsAsJson
		} # counties

		drugTypes: queryDslConnection(
			aggregations: [
				{
					name: "drugType"
					terms: {
						field: "data.drugType"
						minDocCount: 0
						order: "_term ASC"
						size: 100
					}
				}
			]
			first: 0
			query: {
				boolean: {
					must: [
						{
							term: {
								field: "type",
								value: {
									string: "overdosefare:alert"
								}
							}
						}, {
							range: {
								field: "data.expires"
								lt: {
									string: "${now}"
								}
							}
						}
						${county ? `, {
							fulltext: {
								fields: ["data.locationCounty"]
								query: "${county}"
							}
						}` : ''}
					]
				}
			}
		) {
			aggregationsAsJson
		} # drugTypes

		alerts: queryDslConnection(
			after: ${after ? `"${after}"` : null}
			first: ${first}
			query: {
				boolean: {
					must: [
						{
							term: {
								field: "type",
								value: {
									string: "overdosefare:alert"
								}
							}
						}, {
							range: {
								field: "data.expires"
								lt: {
									string: "${now}"
								}
							}
						}
						${county ? `, {
							fulltext: {
								fields: ["data.locationCounty"]
								query: "${county}"
							}
						}` : ''}
						${drugType ? `, {
							fulltext: {
								fields: ["data.drugType"]
								query: "${drugType}"
							}
						}` : ''}
					]
				}
			}
			sort: [{
				direction: DESC
				field: "data.modifiedOrPublished"
			}]
		) {
			totalCount
			edges {
				node {
					...on overdosefare_Alert {
						_id
						data {
							appearance
							description {
								raw
							}
							drugForm
							drugType
							drugTypeSpecific
							expires
							image {
								... on media_Image {
									data {
										altText
										caption
									}
									mediaUrl(type:absolute)
									w1920: imageUrl(scale: "width(1920)")
									x {
										media {
											imageInfo {
												# imageHeight
												imageWidth
											}
										}
									}
								}
							}
							isDrugAnalyzed
							localizedAreaOrCityAndCounty(locale: "${locale}")
							locationAreaOrCity
							locationCounty
							modified
							published
							recommendation {
								raw
							}
							title
						} # data
					} # on overdosefare_Alert
				} # node
			} # edges
			pageInfo {
				startCursor
				endCursor
				hasNext
			}
		} # alerts
	} # guillotine
}`; // query
}
